<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActive"
  >
  <div id="loading-update-ehs-expiration" class="vs-con-loading__container">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{$t('update')}} {{$t('expiration')}}</h4>
      <feather-icon icon="XIcon" @click.stop="close" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <!-- FORM -->
        <form>
          <input-date 
              
              v-model="currentDate" 
              :value="currentDate"
              :label="$t('current_expiration_date')" disabled/>
          <!-- <vs-input
            label="Current Expiration date"
            v-mask="'##/##/####'"
            class="w-full"
            name="currentDate"
            v-validate="'required'"
            v-model="data.date_expiration"
            :disabled="true"
          /> -->
          <input-date 
              v-model="date" 
              :value="date"
              :label="$t('expiration_date')" />
          <!-- <vs-input
            label="Expiration date"
            v-mask="'##/##/####'"
            class="w-full"
            name="date"
            v-validate="'required'"
            v-model="date"
          /> -->
          <div class="mt-4">
            <input
              type="file"
              name="file"
              label="File"
              ref="file"
              class="w-full"
              @change="changeFile"
            />
          </div>
        </form>
      </div>
    </component>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.prevent="submit" :disabled="!validForm">Submit</vs-button>
      <vs-button type="border" color="danger" @click.stop="close">Cancel</vs-button>
    </div>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import InputDate from '@/components/custom/InputDate'
import axios from 'axios'
export default {
  components: {
    VuePerfectScrollbar,
    InputDate
  },
  props: ['ehs'],
  data () {
    return {
      title: 'Update Expiration Date',
      currentDate:'',
      date: '',
      file: '',
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    }
  },
  computed: {
    isSidebarActive () {
      return (
        this.$store.state.sidebar === 'updateEhsExpiration'
      )
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    },
    validForm(){
      return this.file !== '' && this.date !== '' 
    }
  },
  watch: {
    isSidebarActive (val) {
      if (val) {
        this.open()
      }  
    }
  },
  methods: {
    open () {
      this.currentDate = this.ehs.date_expiration
      this.date = ''
      this.file = ''
      this.$refs.file.value = ''
    },
    close () {
      this.$store.dispatch('toggleSidebar','')
    },
    submit() {
      this.openLoading()
      let form = new FormData()
      form.append('id', this.ehs.id)
      form.append('expiration_date',this.date)
      form.append('file', this.file)
      this.$store
        .dispatch('ehs/updateEhsExpiration', form)
        .then(res => {
          this.$store.dispatch('getNotifications')
          this.$vs.notify({
            color: 'success',
            title: 'Success', 
            text: 'Item Added'
          })
          this.closeLoading()
          this.close()
          this.$emit('success')
        })
        .catch(err => {
          this.closeLoading()
          if (422 === err.response.status) {
            const errors = err.response.data.errors
            const errorArray = Object.keys(errors).map(function (key) {
              return [key, errors[key]]
            })
            errorArray.forEach(element => {
              this.$vs.notify({
                color: 'danger',
                title: 'Alert',
                text: element[1][0]
              })
            })
          }
        })
    },
    changeFile () {
      this.file = this.$refs.file.files[0]
    },
    openLoading(){
      this.$vs.loading({
        container: '#loading-update-ehs-expiration',
        scale: 0.6
      })
    },
    closeLoading(){
       this.$vs.loading.close('#loading-update-ehs-expiration > .con-vs-loading')
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
